<template>
  <div class="related-container">
    <h2 v-markdown="relatedarticles.header || 'Like to see more graphics?'"></h2>
    <p class="related-blurb" v-markdown="relatedarticles.blurb || 'Here are some other original graphics you might enjoy. Or visit our <a href=https://www.straitstimes.com/multimedia/graphics>graphics homepage</a>.'"></p>
    <div class="related-articles" v-if="articleList && articleList.length > 0">
      <a :href="article.link" v-for="(article, i) in articleList" :key="i" :title="article.title">
        <div class="article-item">
          <img :src="article.image" alt="image">
          <img v-if="article.premium.toString().toLowerCase() === 'true' || article.premium === true" class="premium-label"
            src="~images_base/label-premium.svg" alt="premium tag">
          <h3 v-markdown="article.title"></h3>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['relatedarticles'],
  data: function () {
    return {
      articleList: []
    }
  },
  mounted () {
    const {articles} = this.relatedarticles
    if (articles && articles.length >= 4) {
      this.articleList = this.shuffleArray(articles)
    } else {
      this.$loading.withLoading(this.fetchArticles)()
    }
  },
  computed: {
    isPremium () {
      return process.env.IS_PREMIUM
    }
  },
  methods: {
    shuffleArray (array) {
      /**
       * Randomize array element order in-place.
       * Using Durstenfeld shuffle algorithm.
       */
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }

      return array
        .filter(item => this.getDirPath(window.location.href) !== this.getDirPath(item.link))
        .slice(0, 4)
    },
    getDirPath (url) {
      var dir = url.substring(0, url.lastIndexOf('/')) + '/'
      return dir
    },
    fetchArticles () {
      let feedUrl = process.env.NODE_ENV === 'production'
                  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
                  : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

      feedUrl += this.relatedarticles.custom || '1jaEjJMg_Hd-_e6_WJggRtswhTOqY-1UQ7J6D116-9YE/0.json'

      return fetch(feedUrl)
        .then(res => res.json())
        .then(data => {
          this.articleList = this.shuffleArray(data)
        }).catch(err => console.log(err))
    }
  }
}
</script>

<style lang="scss">
  .related-container {
    @include container;

    position: relative;
    box-sizing: content-box;
    float: none;
    border-top: 1px double #B4B4B4;
    padding: 20px $outerSpacingMobile;

    @include breakpoint($d_medium) {
      padding: 20px $outerSpacing;
    }

    &::before {
      content: '';
      position: absolute;
      top: 5px;
      left: 0;
      width: 100%;
      border-top: 1px solid #B4B4B4;
    }

    h2 {
      font-family: $font-SelaneTextRegular;
      font-size: 26px;
      line-height: 1.2;
      margin-bottom: 10px;
      color: $black;

      @include breakpoint($d_medium) {
        font-size: 28px;
      }
    }

    .related-blurb {
      font-family: $font-SelaneTextRegular;
      font-size: 16px;
      line-height: 1.2;
      color: $black;

      @include breakpoint($d_medium) {
        font-size: 19px;
      }
    }

    .related-articles {
      margin-top: 20px;

      @include grid_template(1);

      @include breakpoint($d_small) {
        @include grid_template(2);
      }

      @include breakpoint($d_medium) {
        @include grid_template(3);
      }

      @include breakpoint($d_large) {
        @include grid_template(4);
      }

      a {
        border-bottom: none;
      }

      .article-item {
        position: relative;

        img {
          width: 100%;
        }

        img.premium-label {
          display: block;
          margin-bottom: 5px;
          width: 72px;
          height: 20px;
        }

        h3 {
          font-family: $font-SelaneTextRegular;
          font-size: 18px;
          line-height: 120%;
          color: $black;
        }
      }
    }
  }
</style>
